import React from "react";
import { formatTime } from "../../utils/dateTime";
import { gapDuration, gapRoute } from "../../utils/attendanceGaps";

/**
 * Time between check-ins on a day (travel, errands), for whoever reviews it.
 * It doesn't change the hours: they run from first check-in to last check-out.
 * gaps = [{ from, to, minutes, fromClient, toClient }], in time order.
 */
const BetweenCheckIns = ({ gaps }) =>
  gaps?.length ? (
    <div className="small mt-2">
      <div className="fw-semibold">Between check-ins</div>
      <ul className="list-unstyled mb-0 text-muted">
        {gaps.map((g) => {
          const route = gapRoute(g);
          return (
            <li key={`${g.from}-${g.to}`}>
              {formatTime(g.from)} - {formatTime(g.to)},{" "}
              {gapDuration(g.minutes)}
              {route ? `, ${route}` : ""}
            </li>
          );
        })}
      </ul>
    </div>
  ) : null;

export default BetweenCheckIns;
